<template>
    <div class="row g-0">
        <div class="col-12 col-sm-12 col-md-12 col-lg-10">
            <div class="right-side-bar-main-sec deposit_section withdraw_section">
                <div class="go-to-back-sec justify-content-between align-items-center">
                    <div class="go-to-back-sec wallet_back_btn">
                        <a @click="$router.back()">
                            {{ $t('back', 'Back') }}
                        </a>
                    </div>
                    <div class="add_bank_withdrawal_sec">
                        <button type="button"  @click="handleAddAccountModal">
                            <span class="slct_iconplus"><i class="fa-solid fa-plus"></i></span>
                            <span> {{ $t('add-account', 'Add account') }}</span>
                        </button>
                    </div>
                </div>
                
                <div class="dw_bg_cl">
                    <div class="container-fluid">
                        <div class="withdrawal-main-body">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                                    
                                    <div class="depo-lft-container account_detail_cl">
                                        <div class="account_data_parent description-card-withdraw">
                                            <div class="row">
                                                <div v-for="(item, index) in accountsList" :key="index" class="col-12">
                                                <div class="accountItem account-card online-payment-mode-body" :class="{ 'selected-card': selectedCardIndex === index, 'non-selected-card': selectedCardIndex !== index && selectedCardIndex !== null }"  @click="selectCard(index, item.client_account_id)">
                                                    <div class="account_wrap_title">
                                                        <h5 class="account-title">{{ item.method_name ? item.method_name : item.payment_type_name }}</h5>
                                                        <button type="button" @click="selectedRemoveAcc = item; openDeleteModal()"  class="delete-account-btn">
                                                            <i class="fa-solid fa-trash"></i>
                                                        </button>
                                                    </div>
                                                    <div class="accountItem_data_list">
                                                        <p class="card-text" v-if="item?.account_number">
                                                            <label>
                                                                <b>{{ $t('ac-number', 'A/C Number') }}</b> :
                                                                <span>{{ item?.account_number ? item?.account_number : item?.phone_number }}</span>
                                                            </label>
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData($t('ac-number', 'A/C Number'), item?.account_number)">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span> </div>
                                                            </button>
                                                        </p>
                                                        <p class="card-text" v-if="item?.payment_method == 'bank' && item?.ifsc_code">
                                                            <label>
                                                                <b>{{ $t('ifsc-code', 'IFSC Code')  }}</b> :
                                                                <span>{{ item?.ifsc_code }}</span>
                                                            </label>
                                                            <button class="btn txt_copy_cl"  @click="copyPaymentData($t('ifsc-code', 'IFSC Code') , item?.ifsc_code )">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span> </div>
                                                            </button>
                                                        </p>
                                                        <p class="card-text" v-if="item?.payment_method == 'upi' && item?.upi_id">
                                                            <label>
                                                                <b>{{ $t('upi-id', 'UPI ID') }}</b> :
                                                                <span>{{item?.upi_id }}</span>
                                                            </label>
                                                            <button class="btn txt_copy_cl"  @click="copyPaymentData($t('upi-id', 'UPI ID') , item?.upi_id )">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span> </div>
                                                            </button>
                                                        </p>
                                                        <p class="card-text" v-if="item?.payment_method == 'wallet' && item?.crypto_wallet_id">
                                                            <label>
                                                                <b>{{ $t('wallet-id', 'Wallet ID') }}</b> :
                                                                <span>{{ item?.crypto_wallet_id }}</span>
                                                            </label>
                                                            <button class="btn txt_copy_cl"  @click="copyPaymentData($t('wallet-id', 'Wallet ID'), item?.crypto_wallet_id)">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span> </div>
                                                            </button>
                                                        </p>
                                                        <p class="card-text" >
                                                            <label>
                                                                <b>{{ $t('account-holder-name', 'Account Holder’s Name') }}</b> :
                                                                <span>{{ item?.account_holder_name }}</span>
                                                            </label>
                                                            <button class="btn txt_copy_cl"  @click="copyPaymentData(this.$t('account-holder-name', 'Account Holder’s Name'), item?.account_holder_name)">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span> </div>
                                                            </button>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <form class="withdrawalForm">
                                                <div class="avail-bal-box">
                                                    <label>Withdraw Amount</label>
                                                    <input type="number" id="amount" maxlength="10" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.withdrawal_range?.max || 99999999)" class="form-control withdraw_amount_input" :placeholder="$t('enter-amount','Enter Amount')" v-model="amount">
                                                    <span class="avail-bal" style="pointer-events: none;">
                                                        <span class="text-green">Available Bal: {{ availableBalance }}</span>
                                                    </span>
                                                </div>
                                                <div class="wallet-minmax">{{ $t('min', 'Min') }}: {{ walletConfig?.withdrawal_range?.min }} | {{ $t('max', 'Max') }}: {{ walletConfig?.withdrawal_range?.max }}</div>
                                                <button :class="{'btn-disabled' : amount < walletConfig?.withdrawal_range?.min }" type="button" class="withdrawBtn" @click="withdrawAmountFuncCall()">
                                                    {{ $t('withdraw', 'Withdraw') }}
                                                </button>
                                            </form>

                                            <div class="forget-password-sec">
                                                <a href="javascript:void(0)" class="blue-link" @click="openWithdrawPasswordModal()">{{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?</a>
                                            </div>

                                            <div class="delete_account_modal">
                                                <div class="modal fade worli-Bets-Modal" id="editnavModal" ref="deleteModalRef" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                    <div class="modal-dialog modal-dialog-centered">
                                                        <DeleteAccount  v-if="selectedRemoveAcc" @yes-click="removeAccountHere()" @close="closeModal()" :item="selectedRemoveAcc" />
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>

                                        <div class="depo-lft-container">
                                            <WalletInstructions instructionType="withdrawal" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                                    <div class="withdrawal_rgt_container transition_table_cl">
                                        <WalletHistory  ref="wallet_history"></WalletHistory>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AddBankAccount ref="addBankRef"  :getAccountDetailList = "getAccountDetailList" :paymentMethodList="paymentMethodList"/>
    <WithdrawalPasswordSetReset ref="withdrawSetReset" />
    <WalletInstructionVideos langKey="Withdraw"/>
</template>

<script>

import { defineAsyncComponent } from 'vue';
import {getUserAccounts, withdrawWalletAmount, withdrawAmountClickValidation} from '../services/walletWithdraw';
import { openWithdrawPasswordModal } from '../services/withdrawAccountDetails';
import WalletInstructions from '../components/WalletInstructions.vue';
import WalletInstructionVideos from '../components/WalletInstructionVideos.vue';
import WalletHistory from '../components/WalletHistory.vue';
import DeleteAccount from '../components/DeleteAccount.vue';
import WithdrawalPasswordSetReset from '../components/WithdrawalPasswordSetReset.vue';
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
import AddBankAccount from '../components/AddBankAccount.vue';

export default {
    name: "WalletWithdraw",
    inject: ['walletConfig'],
    components: {
        AddBankAccount,
        NoDataFound,
        WithdrawalPasswordSetReset,
        DeleteAccount,
        WalletHistory,
        WalletInstructionVideos,
        WalletInstructions,
    },
    data() {
        return {
            is_withdrawal_password_set:false,
            amount: '',
            loading: false,
            accountsList: [],
            selectBankId: null,
            selectedRemoveAcc: null,
            selectedCardIndex: null,
            copiedText: null,
            paymentMethodList: null
        }
    },
    computed: {
        availableBalance() {
            return ((+this.$auth.user?.balance || 0) - (+this.$auth?.user?.earnBonus || 0) + parseInt(this.$auth.user?.expl || 0)).toFixed(2);
        },
    },
    mounted() {
        this.getAccountDetailList();
	},
    methods: {
		async openWithdrawPasswordModal(){
            try{
                this.OTPloading = true;
                let response = await openWithdrawPasswordModal()
                this.OTPloading = false;
                if(!response?.error){
                    this.$helper.openModal('#withdrawalPassword');
                    this.$refs.withdrawSetReset.otpHasBeenCalled()
                    this.$refs.withdrawSetReset.resetTimer();
                }else{
                    this.$errorToast(response?.error);
                }
            }
            catch(error){
                this.OTPloading = false;
                if(error) {
                    this.$errorToast(error);
                }
            }
        },
        handleAddAccountModal(){
            this.$helper.openModal('#acc-open-model');
        },
        selectCard(index, bankId) {
            this.selectedCardIndex = index;
            this.selectBankId = bankId;
        },
        openDeleteModal() {
			this.$nextTick(() => {
                this.$helper.openModal('#editnavModal')
			});
		},
        removeAccountHere() {
			this.closeModal();
            this.getAccountDetailList();
		},
		closeModal() {
            this.selectedRemoveAcc = null;
			const closeButton = document.getElementById('closeBtn');
            if (closeButton) {
                closeButton.click();
            }
		},
        async withdrawAmountFuncCall() {
            if(this.accountsList?.length == 0){
                this.$errorToast('Add Account to withdraw')
                return
            }
            let isValid = await withdrawAmountClickValidation(this.amount, this.walletConfig, this.availableBalance);
            if (isValid) {
                this.$store.dispatch('setGlobalLoader', true);
                let response = await withdrawWalletAmount(this.amount, this.selectBankId);
                this.$store.dispatch('setGlobalLoader', false);
                if (!response?.error) {
                    this.$router.push({name: "Home"});
                } else {
                    console.error('Withdrawal error:', response.error);
                }
            }
		},
        async getAccountDetailList(reconnectTry = 0) {
            try{
                let response = await getUserAccounts(this.walletConfig?.payment_method, reconnectTry)
                this.accountsList = response.userAccounts
                this.paymentMethodList = response.paymentMethods;
                if (this.accountsList.length > 0) {
                    this.selectedCardIndex = 0;
                    this.selectBankId = this.accountsList[0].client_account_id;
                }
            }
            catch(error){
                this.loading = false;
                if (error) {
                    this.$errorToast(error?.[0]);
                }
            }
        },
        copyPaymentData(catagory, accountData) {
            var input = document.createElement('textarea');
            input.innerHTML = accountData;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);      
            this.copiedText = accountData;
            this.$successToast(catagory + ' Copied Successfully');
            document.querySelectorAll('.copt_btn_toolTips .txt_copy_cl i').forEach(el => {
                el.style.color = '';
            });
            setTimeout(() => {
                this.copiedText = null;
                document.querySelectorAll('.txt_copy_cl i').forEach(el => {
                    el.style.color = '#f36c21';
                });
            }, 1000);
        }
    }
   
}
</script>
<style scoped>
.btn-disabled{
  pointer-events: none;
  opacity: 0.5;
}
</style>